import { axiosInstance } from '@/config/axios.config';
import { GlowUpProduct } from '@repo/types/src/glow-up-product';

export const getAllGlowUpProducts = async () => {
  const response = await axiosInstance.get<GlowUpProduct[]>(
    '/glow-up/category/admin',
  );
  return response.data;
};

const buildFormData = (payload: {
  categoryId: number;
  title: string;
  description?: string;
  link: string;
  ctaText: string;
  position?: number;
  active?: boolean;
  file?: File;
}) => {
  const formData = new FormData();
  if (payload.file) formData.append('file', payload.file);
  formData.append('categoryId', String(payload.categoryId));
  formData.append('title', payload.title);
  if (payload.description !== undefined)
    formData.append('description', payload.description);
  formData.append('link', payload.link);
  formData.append('ctaText', payload.ctaText);
  if (payload.position !== undefined)
    formData.append('position', String(payload.position));
  if (payload.active !== undefined)
    formData.append('active', String(payload.active));
  return formData;
};

export const createGlowUpProduct = async (payload: {
  categoryId: number;
  title: string;
  description?: string;
  link: string;
  ctaText: string;
  position?: number;
  active?: boolean;
  file: File;
}) => {
  const response = await axiosInstance.post<GlowUpProduct>(
    '/glow-up/category/admin',
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const updateGlowUpProduct = async (
  id: number,
  payload: {
    categoryId: number;
    title: string;
    description?: string;
    link: string;
    ctaText: string;
    position?: number;
    active?: boolean;
    file?: File;
  },
) => {
  const response = await axiosInstance.patch<GlowUpProduct>(
    `/glow-up/category/admin/${id}`,
    buildFormData(payload),
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
};

export const activateGlowUpProduct = async (id: number) => {
  const response = await axiosInstance.patch<GlowUpProduct>(
    `/glow-up/category/admin/${id}/activate`,
  );
  return response.data;
};

export const deactivateGlowUpProduct = async (id: number) => {
  const response = await axiosInstance.patch<GlowUpProduct>(
    `/glow-up/category/admin/${id}/deactivate`,
  );
  return response.data;
};

export const deleteGlowUpProduct = async (id: number) => {
  const response = await axiosInstance.delete<GlowUpProduct>(
    `/glow-up/category/admin/${id}`,
  );
  return response.data;
};

export const reorderGlowUpProducts = async (
  items: { id: number; position: number }[],
) => {
  const response = await axiosInstance.patch<GlowUpProduct[]>(
    '/glow-up/category/admin/reorder',
    { items },
  );
  return response.data;
};
